import { appReducer } from "./app/app.reducer";
import { orgsReducer } from "../api/vigilant/orgs/orgs.reducer";
import { usersReducer } from "../api/vigilant/users/users.reducer";
import { realmsReducer } from "../api/vigilant/realms/realms.reducer";

export const appReducers = {
  app: appReducer,  
  orgs: orgsReducer,

  users: usersReducer,
  realms: realmsReducer
};
